import AllFundPerformance from './AllFundComponents/AllFundPerformance'
import AllFundPeriodicPerformance from './AllFundComponents/AllFundPeriodicPerformance'
import AllFundPrices from './AllFundComponents/AllFundPrices'
import AllFundRecentDistributions from './AllFundComponents/AllFundRecentDistributions'
import AnnualizedReturns from './AnnualizedReturns'
import CountryAllocation from './CountryAllocation'
import SingleTableCurrentPrice from './CurrentPrice/SingleTableCurrentPrice'
import DistributionHistory from './DistributionHistory'
import Duration from './Duration'
import EtfCommodityIndexSectors from './EtfCommodityIndexWeights'
import EtfDistributionHistory from './EtfDistributionHistory'
import EtfFundFacts from './EtfFundFacts'
import EtfPricingTrading from './EtfPricingTrading'
import DailyFullHoldingsEquity from './FullHoldings/DailyFullHoldingsEquity'
import DailyFullHoldingsFixedIncome from './FullHoldings/DailyFullHoldingsFixedIncome'
import FullHoldingsEquity from './FullHoldings/FullHoldingsEquity'
import FullHoldingsFixedIncome from './FullHoldings/FullHoldingsFixedIncome'
import FundFacts from './FundFacts'
import FundOverviewTopHoldingsEquity from './FundOverviewTopHoldingsEquity'
import HistoricalPremiumDiscountChart from './HistoricalPremiumDiscountChart'
import MaturityProfile from './MaturityProfile'
import PeriodicTotalReturnsWrapper from './PeriodicTotalReturnsWrapper/PeriodicTotalReturnsWrapper'
import PortfolioCharacteristics from './PortfolioCharacteristics'
import PriceHistoryChart from './PriceHistoryChart'
import PriceHistorySearchForm from './PriceHistorySearchForm'
import SectorAllocations from './SectorAllocations'
import SectorReturns from './SectorReturns'
import TopHoldingsEquity from './TopHoldingsEquity'
import TopHoldingsFixedIncome from './TopHoldingsFixedIncome'
import TotalReturnsWrapper from './TotalReturnsWrapper/TotalReturnsWrapper'

// Map component names (strings) to their respective component modules
const componentMapping = {
  AllFundPerformance,
  AllFundPeriodicPerformance,
  AllFundPrices,
  AllFundRecentDistributions,
  AnnualizedReturns,
  CountryAllocation,
  SingleTableCurrentPrice,
  DistributionHistory,
  Duration,
  EtfCommodityIndexSectors,
  EtfDistributionHistory,
  EtfFundFacts,
  EtfPricingTrading,
  DailyFullHoldingsEquity,
  DailyFullHoldingsFixedIncome,
  FullHoldingsEquity,
  FullHoldingsFixedIncome,
  FundFacts,
  FundOverviewTopHoldingsEquity,
  HistoricalPremiumDiscountChart,
  MaturityProfile,
  PeriodicTotalReturnsWrapper,
  PortfolioCharacteristics,
  PriceHistoryChart,
  PriceHistorySearchForm,
  SectorAllocations,
  SectorReturns,
  TopHoldingsEquity,
  TopHoldingsFixedIncome,
  TotalReturnsWrapper,
}

// Export the component mapping object as the default export
export default componentMapping
